// import qs from 'qs';
import request from '@/utils/request';
// 引入 Vuex 的数据
import store from '@/store';

// 获取学校资源
export const school = () => request({
  method: 'GET',
  url: '/api/greengage/map/getInfo',
});

// 获取微信签名
export const wxConfig = (url) => request({
  method: 'GET',
  url: `/api/wechatConfig?id=${store.state.id}&url=${url}`,
});

// 传递用户经纬度
export const geolocation = (data) => request({
  method: 'POST',
  url: '/api/greengage/user/location',
  data,
});

// 获取3D地球数据
export const globe = () => request({
  method: 'GET',
  url: '/api/greengage/user/location_list',
});

// 获取全球地图、中国地图、统计数据
export const statistics = (type, page, pagesize = 100000, hideLoading = false) => request({
  method: 'GET',
  url: `/api/greengage/user/statistics?type=${type}&page=${page}&pagesize=${pagesize}`,
  hideLoading,
});

export const rank = (hideLoading = false) => request({
  method: 'GET',
  url: '/api/greengage/user/location_rank',
  hideLoading,
});

// 获取b北师大小程序跳转地址
export const weapp = (data) => request({
  baseURL: 'https://bsdr.bnu.edu.cn',
  method: 'POST',
  url: '/api/wx/generate_url',
  data,
});

// 百度地图开放平台坐标转换接口 弃用
// export const baidugps = (coords) => request({
//   baseURL: 'https://api.map.baidu.com',
//   method: 'GET',
//   url: `/geoconv/v1/?coords=${coords}&from=3&to=5&ak=OynGivQ7KmNnNV1MHrvbFlUszw3qIabV`,
// });
